import { render, staticRenderFns } from "./RegisterProjectUserForm.vue?vue&type=template&id=18134caa&scoped=true"
import script from "./RegisterProjectUserForm.vue?vue&type=script&lang=js"
export * from "./RegisterProjectUserForm.vue?vue&type=script&lang=js"
import style0 from "./RegisterProjectUserForm.vue?vue&type=style&index=0&id=18134caa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18134caa",
  null
  
)

export default component.exports